import PurchaseEntryForm from 'components/Form/Tenant/Purchase/PurchaseEntryForm';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

const PurchaseEntryPage: React.FC = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  return (
    <div className="page-content">
      <Container fluid>
        <PurchaseEntryForm invoiceId={invoiceId || ''} />
      </Container>
    </div>
  );
};

export default PurchaseEntryPage;
